import React, { FC } from 'react'
import { IonPage } from '@ionic/react'
import { StyledIonContent } from './Page.styles'
import { Header } from '@src/components/Desktop/Sections/Header'

interface PageProps {
  children?: React.ReactNode
}

export const Page: FC<PageProps> = ({ children }) => (
  <IonPage>
    <Header />
    <StyledIonContent>{children}</StyledIonContent>
  </IonPage>
)
